import * as React from "react";
// @ts-ignore
import style from "./Content.module.scss?module";

export default function Content(props) {
  return <div className={style.content}>{props.children}</div>;
}
